import classNames from 'classnames'
import { memo, useCallback, useEffect } from 'react'
import { message } from 'antd'
import copy from 'copy-to-clipboard'
import { CodeEditor } from '@/features/editor'
import { NodeForm } from '@/components'
import { Webhook } from '@/features/nodes/start/components/Webhook'
import { useLogger } from '../context'
import { logItem2FormValues } from '@/features/logger/utils/logItem'
import { transformConfig2SchemaConfig } from '@/features/nodes/start/utils.ts'

export const LoggerInput = memo(() => {
  const { flowLog, formConfig, flowStartType, mode } = useLogger()

  const [form] = NodeForm.useForm()

  useEffect(() => {
    if (form && flowLog) {
      form.setFieldsValue(logItem2FormValues(flowLog))
    }
  }, [flowLog, form])

  const onCopy = useCallback((text: string) => {
    copy(text)
    message.success('复制成功')
  }, [])
  return (
    <>
      {flowStartType === 'form' && (
        <NodeForm
          form={form}
          disabled={mode === 'log'}
          // disabled={props.disabled || isDiff}
          schema={transformConfig2SchemaConfig(formConfig)}
          // onValuesChange={onValuesChange}
        />
      )}
      {flowStartType === 'webhook' && (
        <div className='flex flex-col h-full'>
          <Webhook style={{ padding: 0, marginBottom: 20 }} />
          <div
            className={classNames('flex-1', {
              // 'p-b-36': !props.hiddenButton,
            })}
          >
            <CodeEditor
              width='100%'
              theme='tomorrow'
              mode='json'
              disabled={mode === 'log'}
              // disabled={props.disabled || isDiff}
              setOptions={{
                maxLines: 31,
                hasCssTransforms: false,
              }}
              placeholder='填写JSON参数，模拟Webhook调用'
              value={flowLog?.input}
              // onChange={onJsonValueChange}
              copy
              onCopy={onCopy}
            />
          </div>
        </div>
      )}
    </>
  )
})
